export default (function (siteVariables) { return ({
    borderColor: undefined,
    borderWidth: 2,
    successBackgroundColor: siteVariables.successStatusBackgroundColor,
    successTextColor: siteVariables.successStatusTextColor,
    infoBackgroundColor: siteVariables.infoStatusBackgroundColor,
    infoTextColor: siteVariables.infoStatusTextColor,
    warningBackgroundColor: siteVariables.warningStatusBackgroundColor,
    warningTextColor: siteVariables.warningStatusTextColor,
    errorBackgroundColor: siteVariables.errorStatusBackgroundColor,
    errorTextColor: siteVariables.errorStatusTextColor,
    defaultBackgroundColor: siteVariables.unknownStatusBackgroundColor,
    defaultTextColor: siteVariables.unknownStatusTextColor,
}); });
